import React from "react";
import { useNavigate } from "react-router-dom";
import { Coins, Users, ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { useLeads } from "../../hooks/useLeads";
import { LeadSearchForm } from "./LeadSearchForm";

const Balance = ({ L }) => (
  <div data-testid="lead-balance" className="rounded-full bg-[#1B3A4B] text-white px-3 py-1 text-xs inline-flex items-center gap-1.5">
    <Coins className="w-3.5 h-3.5 text-[#C5A059]" />
    {L.trialAvailable ? "1 free trial lead" : `${L.leadCoins} lead coin${L.leadCoins === 1 ? "" : "s"}`}
  </div>
);

export const LeadsPanel = ({ user }) => {
  const L = useLeads(false);
  const navigate = useNavigate();
  return (
    <section data-testid="leads-panel" className="bg-white/80 backdrop-blur-md border border-[#E2DCD2] rounded-xl shadow-sm p-5">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <Users className="w-4 h-4 text-[#A6844A]" />
          <h3 className="font-semibold text-[#1C1915]">Find leads</h3>
        </div>
        {user && <Balance L={L} />}
      </div>
      {!user ? (
        <div className="mt-3 text-sm text-[#5C564E]">
          Search the web for real people, businesses and public bids that need your trade.
          <Button data-testid="leads-panel-signin" onClick={() => navigate("/login")} className="mt-3 w-full rounded-full bg-[#1B3A4B] hover:bg-[#132A37] text-white h-10">Sign in to find leads</Button>
        </div>
      ) : (
        <div className="mt-4">
          <LeadSearchForm L={L} compact />
          {L.batch?.length > 0 && (
            <div data-testid="leads-panel-ready" className="mt-3 rounded-lg bg-[#E7D7B8]/60 px-3 py-2 text-sm text-[#1B3A4B]">
              {L.batch.length} new lead{L.batch.length === 1 ? "" : "s"} ready on your Leads page.
            </div>
          )}
          <button data-testid="leads-panel-open-leads" onClick={() => navigate("/leads")} className="mt-3 text-sm text-[#1B3A4B] font-medium underline underline-offset-2 inline-flex items-center gap-1">
            Open Leads page <ArrowRight className="w-3.5 h-3.5" />
          </button>
        </div>
      )}
    </section>
  );
};
